import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { CollectionState } from "@/components/CollectionsPage/redux/types";

const selectCollection = (state: RootState): CollectionState => state?.collection;

export default createDraftSafeSelector(
  selectCollection,
  (collection: CollectionState): any => collection?.collectionData
);
